module.exports = __webpack_public_path__ + "static/GumArabic-2aa9583a17050255834926fa4c922305.webp";